export default __webpack_public_path__ + "static/media/CustomQuadroo.06836cd7.png";